import { Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import KeepAlive from "react-activation";
import { redirects, routes } from "./router";
import TabShell from "@/layouts/TabShell";

import "./app.scss";
function App() {
  const location = useLocation();

  const fallback = <div className="app-loading">Loading...</div>;

  const tabRoutes = routes.filter((r) => r.isTab);
  const otherRoutes = routes.filter((r) => !r.isTab);
  return (
    <Routes>
      <Route element={<TabShell />}>
        {tabRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              route.keepAlive ? (
                <KeepAlive cacheKey={location.pathname}>
                  <Suspense fallback={fallback}>
                    <route.component />
                  </Suspense>
                </KeepAlive>
              ) : (
                <Suspense fallback={fallback}>
                  <route.component />
                </Suspense>
              )
            }
          />
        ))}
      </Route>

      {otherRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            route.keepAlive ? (
              <KeepAlive cacheKey={location.pathname}>
                <Suspense fallback={fallback}>
                  <route.component />
                </Suspense>
              </KeepAlive>
            ) : (
              <Suspense fallback={fallback}>
                <route.component />
              </Suspense>
            )
          }
        />
      ))}

      {redirects.map((redirect) => (
        <Route
          key={redirect.path}
          path={redirect.path}
          element={<Navigate to={redirect.redirect} replace={redirect.replace} />}
        />
      ))}
    </Routes>
  );
}

export default App;
